export default function AddReviewIntro() {
  return (
    <>
      <div id='add-review-intro' className='banner-image-text'>
        <img
          src="../../images/reviews/write-review.jpg"
          alt="Person writing a review, and giving the house a 4 star rating"
          className='full-width-image'
        />
      </div>
      <div className='responsive-text'>
       <h2>Owners only – Add a new review</h2>
      </div>
    </>
  );
}